import { render, staticRenderFns } from "./ModeratorIcon.vue?vue&type=template&id=1949cf04&"
import script from "./ModeratorIcon.vue?vue&type=script&lang=js&"
export * from "./ModeratorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports